<mono-common-back-to-navigation-bar
  data-test="lmw-base-topic-landing-back-to-topic"
  [linkText]="subjectName"
  linkTo="../"
  position="back-to-navigation__top"
></mono-common-back-to-navigation-bar>
<main
  id="content"
  #content
  class="grid-container site-container site-container--topic-landing"
  aria-describedby="ariaMainHeaderId"
>
  <div class="grid-x grid-margin-x">
    <div class="cell medium-6 position-relative">
      <h1 id="ariaMainHeaderId">{{ topic.title }}</h1>
      <p class="lead" *ngIf="topic.description">{{ topic.description }}</p>
      <button
        [disabled]="requiresSignIn && !userSignedIn"
        [ngClass]="
          (requiresSignIn && !userSignedIn) || userSignedIn
            ? 'margin-bottom-1'
            : ''
        "
        class="button large primary medium-down-expanded"
        (click)="startLearningClicked()"
      >
        {{ topicLandingCms?.data?.attributes?.startButton }}
      </button>
      <mono-common-callout
        *ngIf="requiresSignIn && !userSignedIn"
        base="info"
        type="info-box"
        [calloutText]="topicLandingCms?.data?.attributes?.lockedTopicInformation"
        paddingOrMarginAlteration="position-relative width-100"
        data-test="topic-landing-component-callout-requiresSignIn"
      >
      </mono-common-callout>
      <ng-container *ngIf="userSignedIn">
        <p
          class="topic-completed"
          *ngIf="topicCompletedDate !== '' && !topicCompletedDate"
        >
          &nbsp;
        </p>
        <p
          *ngIf="topicCompletedDate === ''"
          data-test="topic-landing-component-topic-not-completed"
          class="topic-completed"
        >
          {{ translate("Not completed yet") | async }}
        </p>
        <p
          *ngIf="topicCompletedDate"
          data-test="topic-landing-component-topic-completed"
          class="topic-completed"
        >
          {{ translate("Last completed: " + topicCompletedDate) | async }}
        </p>
      </ng-container>
    </div>
    <div class="cell medium-6 show-for-medium position-relative">
      <div
        class="topic-image banner-image--pixel-depth_1x"
        aria-hidden="true"
        [ngStyle]="{
          'background-image':
            'url(assets/images/topic-landing-subject-' +
            subjectImageNumber +
            '@1x.jpg)'
        }"
      ></div>
      <div
        class="topic-image banner-image--pixel-depth_2x"
        aria-hidden="true"
        [ngStyle]="{
          'background-image':
            'url(assets/images/topic-landing-subject-' +
            subjectImageNumber +
            '@2x.jpg)'
        }"
      ></div>
    </div>
  </div>
</main>
<mono-common-back-to-navigation-bar
  data-test="lmw-base-topic-landing-back-to-topic"
  [linkText]="subjectName"
  linkTo="../"
  position="back-to-navigation__bottom"
></mono-common-back-to-navigation-bar>
